import {Resource} from '@raison/types';
import {MoneyFormat} from '~/library/money-kit';
import {selectAssetsResource, selectCurrencyServiceResource} from '~/redux/assets/assetsResource';
import {selectCurrentCurrency} from '~/redux/assets/assetsSelectors';
import {selectBalancesResource} from '~/redux/balances/balancesResource';
import {CURRENCIES, FIAT_DECIMALS} from '~/shared/constants/currencies';

export const selectTotalBalance = (state: AppModel) =>
    Resource.all(
        selectBalancesResource(state),
        selectAssetsResource(state),
        selectCurrencyServiceResource(state)
    ).mapSuccess(([balances, {total}, currencyService]): Resource.Or<string> => {
        const balancesTotal = balances.reduce((total, balance) => {
            total += currencyService.convertToPrimary(balance.current_value, balance.currency).toNumber();
            return total;
        }, 0);

        const primaryCurrency = selectCurrentCurrency(state);
        const amount = total[primaryCurrency];
        if (typeof amount !== 'number') return Resource.from({isError: true});

        const decimals = CURRENCIES.find(account => account.currency === primaryCurrency)?.decimals_assets;

        return MoneyFormat.from({
            code: primaryCurrency,
            decimals: decimals ?? FIAT_DECIMALS,
        }).localeFormat(amount + balancesTotal);
    });
